import icon_batsu from "../images/batsu.svg";
import icon_sankaku from "../images/sankaku.svg";
import icon_maru from "../images/maru.svg";
import icon_minus from "../images/icon_minus.png";
import icon_hatena from "../images/hatena.svg";
import bikkuri from "../images/bikkuri.svg";
import axios from "axios";

/**
 * 総合判定をアイコンファイルと文言に変換
 * @param {*} icon 
 * @returns 
 */
export function compIconConversion(icon) {
  let result = [];
  if (icon == "〇") {
    result.push(<><div class="kigou"><img src={icon_maru} /></div><div>輸出可</div></>);
  } else if (icon == "△") {
    result.push(<><div class="kigou"><img src={icon_sankaku} /></div><div>輸出可（条件あり）</div></>);
  } else if (icon == "X") {
    result.push(<><div class="kigou"><img src={icon_batsu} /></div><div>輸出不可</div></>);
  } else if (icon == "-") {
    result.push(<><div class="kigou"><img src={icon_minus} /></div><div>対象外</div></>);
  } else if (icon == "?") {
    result.push(<><div class="kigou"><img src={icon_hatena} /></div><div>判定不可</div></>);
  } else if (icon == "!") {
    result.push(<><div class="kigou"><img src={bikkuri} /></div><div>要確認</div></>);
  }
  return result;
}

/**
 * 優先判定（X > △ > 〇 > ! > ? > -）2023/01/27 modify
 * @param {*} icon1 〇△X?-!
 * @param {*} icon2 〇△X?-!
 * @returns true or false
 */
export function priorityJudge(icon1, icon2) {
  if (icon1 == "") {
    return true;
  }

  // 2023/01/27 modify
  let priorityList = [
    "-",
    "?",
    "!",
    "〇",
    "△",
    "X",
  ];

  if (priorityList.indexOf(icon1) < priorityList.indexOf(icon2)) {
    return true;
  } else {
    return false;
  }

  // if(icon1 == "-"){
  //   if (
  //     icon2 == "〇"
  //     || icon2 == "△"
  //     || icon2 == "X"
  //     || icon2 == "!"
  //     || icon2 == "?"
  //   ) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }else if (icon1 == "〇") {
  //   if (
  //     icon2 == "△"
  //     || icon2 == "X"
  //     || icon2 == "!"
  //     || icon2 == "?"
  //   ) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // } else if (icon1 == "△") {
  //   if (
  //     icon2 == "X"
  //     || icon2 == "!"
  //     || icon2 == "?"
  //   ) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // } else if (icon1 == "X") {
  //   if (
  //     icon2 == "!"
  //     || icon2 == "?"
  //   ) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }else if(icon1 == "!"){
  //   if (
  //     icon2 == "?"
  //   ) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }
}

/**
 * 特殊判定（! > ? > -）2023/03/03 modify
 * @param {*} icon1 〇△X?-!
 * @param {*} icon2 〇△X?-!
 * @returns true or false
 */
export function plantPriorityJudge(icon1, icon2) {
  if (icon2 == "〇" || icon2 == "△" || icon2 == "X") {
    return false;
  }

  if (icon1 == "") {
    return true;
  }

  // 2023/03/03 modify
  let priorityList = [
    "-",
    "?",
    "!",
  ];

  if (priorityList.indexOf(icon1) < priorityList.indexOf(icon2)) {
    return true;
  } else {
    return false;
  }
}

/**
 * 植物検疫、放射性の個別判定
 * 条件：
 * - ? ! がある場合は優先で設定
 * 全て〇の場合、〇
 * 全てXの場合、X
 * 〇X△混在の場合、△
 * @param {*} iconArr 
 */
export function PriorityJudgePlantRadio(iconArr) {
  const isMinus = iconArr.some(value => value == "-");
  if (isMinus) {
    return "-";
  }

  const isHatena = iconArr.some(value => value == "?");
  if (isHatena) {
    return "?";
  }

  const isBikkuri = iconArr.some(value => value == "!");
  if (isBikkuri) {
    return "!";
  }

  const isAllOk = iconArr.every(value => value == "〇");
  if (isAllOk) {
    return "〇";
  }

  const isAllNg = iconArr.every(value => value == "X");
  if (isAllNg) {
    return "X";
  }

  return "△";
}

/**
 * 結果画面、結果詳細の品目タイトル表示
 * 検索品目を表示し品目コードと違っていたら「XXの結果を表示しています。」の説明文を　追加
 * @param {*} dataList 
 * @param {*} productName 
 */
export function TableTitle(dataList, productName) {
  if (dataList[0].product_code == productName) {
    return (<>{productName}</>);
  } else {
    return (
      <>
        {productName}　
        <span style={{ fontSize: "14px" }}>
          ※{dataList[0].product_code}の結果を表示しています。
        </span>
      </>
    );
  }
}

// 判定
export function dataJudge(exportability) {
  // packing == 1で無いとき、NAデータを表示（植物検疫）
  // if (data.packing == 1 || dataType != "plan") {
  //   exportability = data.exportability_code;
  // }

  if (
    exportability == "〇"
    || exportability == "△"
    || exportability == "X"
    || exportability == "?"
    || exportability == "-"
    || exportability == "!"
  ) {
    return true;
  } else {
    return false;
  }
}

/**
 * 判定をアイコンファイルに変換
 * @param {*} icon 
 * @returns イメージファイル名
 */
export function iconConversion(icon) {
  let img = "";
  if (icon == "〇") {
    img = icon_maru;
  } else if (icon == "△") {
    img = icon_sankaku;
  } else if (icon == "X") {
    img = icon_batsu;
  } else if (icon == "-") {
    img = icon_minus;
  } else if (icon == "?") {
    img = icon_hatena;
  } else if (icon == "!") {
    img = bikkuri;
  }
  return img;
}

/**
 * 2024/01/23 add
 * IPアドレスを返す
 * 取得できないときはnullを返す
 * @returns IP
 */
export async function fetchIpAddress() {
  let ip = null;
  
  try {
    const response = await axios.get("https://ipinfo.io");
    ip = response.data.ip;
  } catch (error) {
    console.error('Error:', error);
  }

  return ip;
}
